import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ProgressBar } from 'primereact/progressbar';
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { getSocket } from "../context/socket";
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import ChecklistPopup from "./ChecklistPopup";
import ChecklistMemberPage from "./ChecklistMemberPage";
import DeleteChecklist from "./DeleteChecklist";
import ChecklistDeadlinePopup from "./ChecklistDeadlinePopup";
const Checklist = ({ cardId, boardId }) => {
    const socket = getSocket();
    const [activePopup, setActivePopup] = useState(null);
    const [selectedChecklistItemId, setSelectedChecklistItemId] = useState(null);

    const togglePopup = (key) => {
        setActivePopup((prev) => (prev === key ? null : key));
    };
    const [checklistItems, setChecklistItems] = useState([]);
    const [showInput, setShowInput] = useState(false);

    useEffect(() => {
        if (!socket) return;

        // Fetch checklist when component mounts or cardId changes
        const fetchChecklist = () => {
            socket.emit('fetchChecklistItems', { card_id: cardId });
        };

        fetchChecklist();

        // When checklistItemsData is received
        socket.on('checklistItemsData', (data) => {
            setChecklistItems(data);
        });


        const handleChecklistUpdate = ({ card_id }) => {
            if (card_id === cardId) {
                fetchChecklist(); // 🔄 Refresh only if it matches
            }
        };

        socket.on('triggerChecklistUpdate', handleChecklistUpdate);

        // If new checklist item is added for this card, fetch again
        socket.on('addChecklist', (data) => {
            if (data.card_id === cardId) {
                fetchChecklist();
            }
        });

        // Clean up listeners when component unmounts
        return () => {
            socket.off('checklistItemsData');
            socket.off('addChecklist');
            socket.off('triggerChecklistUpdate', handleChecklistUpdate);
        };
    }, [cardId, socket]);

    const handleCheckboxChange = (itemId, checked) => {
        setChecklistItems(prevItems =>
            prevItems.map(item =>
                item.ChecklistItem_id === itemId ? { ...item, is_checked: checked } : item
            )
        );

        socket.emit('updateChecklistChecked', {
            checklistItemId: itemId,
            isChecked: checked,
            card_id: cardId  // Make sure cardId is available in scope
        });
    };


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };

    const handleEditDate = (id) => {
        setSelectedChecklistItemId(id);
        togglePopup("dates");
    };

    const handleAddMember = (id) => {
        setSelectedChecklistItemId(id);
        togglePopup("members");
    };

    const handleConvertToCard = (id) => {
        setSelectedChecklistItemId(id);
        togglePopup("convertcard");
    };

    const handleDeleteChecklist = (id) => {
        setSelectedChecklistItemId(id);
        togglePopup("delete");
    };





    return (
        <>
            <div className="d-flex justify-content-between align-items-start mb-3">
                <h6><i className="pi pi-check-square me-2"></i> <b>SubTasks</b></h6>
                {!showInput && (
                    <Button
                        label="Add"
                        className="py-1 px-2 border-0"
                        severity="info"
                        size="small"
                        icon="pi pi-plus"
                        onClick={() => setShowInput(true)}
                    />
                )}

                {showInput && (
                    <ChecklistPopup
                        onCancel={() => setShowInput(false)}
                        cardId={cardId}
                        boardId={boardId}
                    />
                )}
            </div>

            <div>
                {checklistItems.length > 0 && (
                    <>
                        <div className="d-flex align-items-center gap-1 mb-3">
                            <span style={{ minWidth: '40px', textAlign: 'left', fontWeight: 'bold', fontSize: '12px' }}>
                                {checklistItems.length > 0 ?
                                    `${Math.round(checklistItems.filter(i => i.is_checked).length / checklistItems.length * 100)}%`
                                    : '0%'}
                            </span>
                            <ProgressBar
                                value={checklistItems.length > 0 ?
                                    checklistItems.filter(i => i.is_checked).length / checklistItems.length * 100
                                    : 0}
                                style={{ height: '5px', flex: 1, }}
                            />
                        </div>

                        {checklistItems.map(item => (
                            <div
                                key={item.ChecklistItem_id}
                                className={`d-flex align-items-center gap-3 justify-content-between catdHover py-2 ${item.due_date &&
                                    !item.is_checked &&
                                    new Date(item.due_date).toDateString() === new Date().toDateString()
                                    ? "example-1"
                                    : ""
                                    }`}
                            >

                                <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-start gap-2 me-4">
                                        <Checkbox
                                            inputId={`checkbox-${item.ChecklistItem_id}`}
                                            checked={item.is_checked}
                                            onChange={(e) => handleCheckboxChange(item.ChecklistItem_id, e.checked)}
                                            disabled={item.is_checked} // Disable if already checked
                                        />
                                        <div>
                                            <p className={`d-block mb-0 ${item.is_checked ? 'text-decoration-line-through' : ''}`}>
                                                {item.name}
                                            </p>
                                            <div className="d-flex align-items-center gap-2 mt-2">
                                                <AvatarGroup>
                                                    {item?.members?.map((member) => {
                                                        const fullName = `${member.first_name} ${member.last_name}`;

                                                        return (
                                                            <React.Fragment key={member.id}>
                                                                <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                                                <Avatar
                                                                    id={`avatar-${member.user_id}`}
                                                                    image={member?.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                                    shape="circle"
                                                                    title={fullName}
                                                                    style={{ width: '28px', height: '28px' }}
                                                                />
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </AvatarGroup>
                                                <small className={`text-white rounded ${getDueDateClass(item?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                                    <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                                    {" "}{formatDate(item?.created_date)} - {formatDate(item?.due_date)}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: '100px' }} className="d-flex justify-content-end hoverShow">
                                    <div>
                                        <Button
                                            title="Change Date"
                                            icon="pi pi-calendar"
                                            text
                                            severity="secondary"
                                            className="border-0 p-0 me-2"
                                            onClick={() => handleEditDate(item.ChecklistItem_id)}
                                        />
                                        {activePopup === "dates" && (
                                            <ChecklistDeadlinePopup
                                                onCancel={() => togglePopup("dates")}
                                                togglePopup={togglePopup}
                                                cardId={cardId}
                                                checklistItemId={selectedChecklistItemId}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <Button
                                            title="Add Member"
                                            icon="pi pi-users"
                                            text
                                            severity="secondary"
                                            className="border-0 p-0 me-2"
                                            onClick={() => handleAddMember(item.ChecklistItem_id)}
                                        />

                                        {activePopup === "members" && (
                                            <ChecklistMemberPage
                                                onCancel={() => togglePopup("members")}
                                                togglePopup={togglePopup}
                                                cardId={cardId}
                                                boardId={boardId}
                                                checklistItemId={selectedChecklistItemId}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <Button
                                            title="Convert to Card"
                                            icon="pi pi-folder-plus"
                                            text
                                            severity="secondary"
                                            className="border-0 p-0"
                                            onClick={() => handleConvertToCard(item.ChecklistItem_id)}
                                        />
                                    </div>
                                    <div>
                                        <Button
                                            title="Delete"
                                            icon="pi pi-times"
                                            text
                                            severity="danger"
                                            className="border-0 p-0"
                                            onClick={() => handleDeleteChecklist(item.ChecklistItem_id)}
                                        />
                                        {activePopup === "delete" && (
                                            <DeleteChecklist
                                                onCancel={() => togglePopup("delete")}
                                                togglePopup={togglePopup}
                                                cardId={cardId}
                                                boardId={boardId}
                                                checklistItemId={selectedChecklistItemId}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                )}






            </div>
        </>
    );
};

export default Checklist;
